import React from 'react';
import type {TdProps} from '@components/Table/core/Td';
import type {Claim} from '@deezer/next/services/api/Starmania/requests/claim/types';
import ArtistClaimCell from './ArtistClaimCell';
import ManagerClaimCell from './ManagerClaimCell';
import ProviderClaimCell from './ProviderClaimCell';
import LabelClaimCell from './LabelClaimCell';

type ClaimDetailCellProps = {
	claim: Claim;
	onToggle: () => void;
	isCollapsed: boolean;
} & TdProps;

const ClaimDetailCell = ({
	claim,
	isCollapsed,
	onToggle,
	...rest
}: ClaimDetailCellProps) => {
	switch (claim.stakeholderType) {
		case 'Artist':
			return <ArtistClaimCell claim={claim} {...rest} />;
		case 'Manager':
			return (
				<ManagerClaimCell
					claim={claim}
					onToggle={onToggle}
					isCollapsed={isCollapsed}
					{...rest}
				/>
			);
		case 'Provider':
			return <ProviderClaimCell claim={claim} {...rest} />;
		case 'Label':
			return <LabelClaimCell claim={claim} {...rest} />;
		default:
			return null;
	}
};

export default ClaimDetailCell;
